import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { AuthRoutingService } from '@awo-care/shared-auth';

@Injectable({
  providedIn: 'root',
})
export class ClaimGuard {
  private router = inject(Router);
  private userService = inject(UserService);
  private authRoutingService = inject(AuthRoutingService);

  async canActivate(): Promise<boolean> {
    if (!this.userService.isInitialized()) {
      await this.userService.loadClaims();
    }

    const user = this.userService.currentUser();

    if (!user || !user.uid) {
      // Redirect to local login route
      await this.router.navigate(['/auth/login']);
      return false;
    }

    // Phone-only users don't have an email to verify — skip email verification
    const isPhoneOnly = !user.email && !!user.phoneNumber;
    if (!user.emailVerified && !isPhoneOnly) {
      // Redirect to local verify-email route
      await this.router.navigate(['/auth/verify-email']);
      return false;
    }

    return true;
  }
}
